<template>
  <div>
    <Navbar v-if="$route.meta.navbar"/>
    <Breadcrumb v-if="$route.meta.navbar" />
    
    <!-- Delete Confirmation Modal -->
    <div 
      class="modal fade" 
      :class="{'show d-block': deleteShow}" 
      tabindex="-1"
      :style="{display: deleteShow ? 'block' : 'none'}"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Delete record?</h5>
            <button type="button" class="btn-close" @click="cancelDeleteItem"></button>
          </div>
          <div class="modal-body">
            Do you really want to delete this record?
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="cancelDeleteItem">Cancel</button>
            <button class="btn btn-danger" @click="deleteItem">Yes, delete</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="deleteShow" class="modal-backdrop fade show"></div>
    
    <div class="row">
      <div class="col-4">
        <BaseTree
          ref="folderTree"
          v-model="treeitems"
          :indent="20"
          class="maintenance-tree"
        >
          <template #default="{ node, stat }">
            <div class="tree-node-inner d-flex align-items-center" @click="handleNodeClick(node)">
              <span class="toggle-icon me-1" style="width: 16px; display: inline-block;">
                <fa-icon
                  v-if="!stat.open && node.children && node.children.length > 0 && node.data.id > 0"
                  name="caret-right"
                  @click.stop="stat.open = true"
                  style="cursor: pointer;"
                />
                <fa-icon
                  v-if="stat.open && node.children && node.children.length > 0 && node.data.id > 0"
                  name="caret-down"
                  @click.stop="stat.open = false"
                  style="cursor: pointer;"
                />
              </span>
              <fa-icon
                v-if="(!node.children || node.children.length === 0) && node.data.id > 0"
                class="me-2"
                name="trash"
                @click.prevent.stop="confirmDeleteItem(node)"
                style="cursor: pointer;"
              />
              <fa-icon
                v-if="node.data.id == 0"
                class="me-2"
                name="plus"
              />
              <span v-if="node.data.id == 0" style="cursor: pointer;">
                {{ node.title }}
              </span>
              <span v-else-if="node.data.id == -1" style="cursor: pointer;">
                <strong>{{ node.title }}</strong>
              </span>
              <span v-else style="cursor: pointer;">
                {{ node.title }}
              </span>
            </div>
          </template>
        </BaseTree>
      </div>
      <div class="col-8">
        <div v-if="loading" class="text-center">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <MaintenanceDetail
          v-if="maintenanceid > -1 && !loading"
          :key="maintenancetable+maintenanceid"
          :tablename="maintenancetable"
          :standalone="maintenanceid"
          :mainfield="mainfield"
          :mainvalue="mainvalue"
          nosubtables="true"
          noedit="false"
          ismodal="false"
          istree="true"
          @modalSave="e => init(e)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { config } from '../../../config';
const base_url = config.base_url;
const api_token = config.api_token;
import Navbar from '../Navbar.vue'
import Breadcrumb from '../Breadcrumb.vue';
import MaintenanceDetail from './MaintenanceDetail.vue'
import { BaseTree } from '@he-tree/vue'
import '@he-tree/vue/style/default.css'

export default {
  name: 'MaintenanceeTree',
  props: [
    'tablename',
     'noedit',
    'noexport',
    'nosearch',
    'fixedfilter',
  ],
  components: {
    Navbar,
    Breadcrumb,
    MaintenanceDetail,
    BaseTree
  },
  data: () => {
    return {
      dbfields: [],
      treeitems: [],
      maintenancetable: '',
      maintenanceid: -1,
      mainfield: '',
      mainvalue: 0,
      currenttable: '',
      currenttableid: 0,
      filter: null,
      loading: true,
      deleteShow: false,
      deletingTable: '',
      deletingItem: 0,
      maxtreeid: 0,
    }
  },
  created() {
    this.init(0);
  },
  watch: {
    '$route.path': function() {
        this.init();
    },
  },
  methods: {
    confirmDeleteItem(node) {
      this.deletingItem = node.data.id;
      this.deletingTable = node.data.table;
      this.deleteShow = true;
    },
    cancelDeleteItem() {
      this.deleteShow = false;
      this.deletingItem = 0;
      this.deletingTable = '';
    },
    deleteItem() {
      if (this.deletingItem > 0) {
        axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
        axios.delete(
          base_url+"/"+this.deletingTable+"/"+this.deletingItem,
          {
            headers: {
                "Accept": "application/json",
                "Content-type": "application/json",
            }
          }
        )
        .then(() => {
          this.deleteShow = false;
          this.deletingItem = 0;
          this.deletingTable = '';
          this.init();
        })
      }
    },
    handleNodeClick(node) {
      this.maintenancetable = '';
      this.maintenanceid = -1;
      if (node.data.id > -1) {
        this.maintenancetable = node.data.table;
        this.maintenanceid = node.data.id;
        this.mainfield = node.data.mainfield;
        this.mainvalue = node.data.mainvalue;
        this.currenttable = node.data.table;
        this.currenttableid = node.data.id;
      }
    },
    async init() {
      await this.$nextTick();
      this.maintenanceid = -1;
      this.treeitems = await this.tree_get(this.tablename, '','','')
      if (this.currenttable != '') {
        await this.$nextTick();
        let folderTree = this.$refs.folderTree;
        folderTree.traverse(
          (node) => {
            if (node.data.table == this.currenttable && node.data.id == this.currenttableid) {
              this.$nextTick(() => folderTree.updateNode([1], { isExpanded: true }))
              for (let i=0;i<node.path.length-1;i++) {
                const thispath = node.path.slice(0,i+1);
                this.$nextTick(() => folderTree.select(thispath, false))
                this.$nextTick(() => folderTree.updateNode(thispath, { isExpanded: true }))  
              }
            }
          }
        )
      }
    },
    tree_get(table, mainfield, mainvalue, heading) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
      return new Promise((resolve) => {
        axios.get(
          base_url+"/fields/"+table,
          '', {
            headers: {
                "Accept": "application/json",
                "Content-type": "application/json",
            }
          }
        )
        .then(resp => {
          let dbfields = resp.data;
          let displayfield = '';
          for (let i = 0;i<dbfields.length && displayfield == '';i++) {
            if (dbfields[i].field_type == 'VARCHAR') {
              displayfield = dbfields[i].field_name;
            }
          }
          let orderby = table+".id";
          let orderdesc = false;
          const s = dbfields.filter(a => a.key_field && a.key_field != "0")
          .map((a) => {
            return {
              orderby: a.field_name,
              orderdesc: a.key_field == 2?true:false,
            }
          });
          if (s.length > 0) {
            orderby = s[0].orderby;
            orderdesc = s[0].orderdesc;
          }
          if (displayfield == '') { displayfield = 'id'; }
          return {
            table,
            dbfields,
            displayfield,
            orderby,
            orderdesc
          };
        })
        .then(async(resp) => {
          let returntree = [];
          const dbfields = resp.dbfields;
          let subfieldtable = ''
          let subfieldfield = ''
          let subfieldcaption = '';
          for (let i=0; i<dbfields.length && subfieldtable == ''; i++) {
            if (dbfields[i].field_type == 'TABLE') {
              subfieldtable = dbfields[i].field_name;
              subfieldfield = dbfields[i].lookup_field;
              subfieldcaption = dbfields[i].list_caption || dbfields[i].input_caption;
            }          
          }
          let records = await this.data_get(table,mainfield,mainvalue, resp.orderby, resp.orderdesc)
          
          // Only add heading if there is one
          if (heading) {
            returntree.push({
              title: heading,
              children: null,
              data: {
                id: -1,
                table: table,
                mainfield,
                mainvalue
              }
            });
          }

          for (let i=0; i<records.length; i++) {
            this.maxtreeid += 1;
            let itemChildren = null;
            if (subfieldtable != '') {
              const subrecords = await this.tree_get(subfieldtable, subfieldfield, records[i].id, subfieldcaption);
              if (subrecords && subrecords.length > 0) {
                itemChildren = subrecords;
              }
            }
            
            returntree.push({
              title: records[i][resp.displayfield],
              children: itemChildren,
              data: {
                id: records[i].id,
                table: table,
                mainfield,
                mainvalue,
              }
            });
          }
          
          // Add "Add new..." option
          returntree.push({
            title: 'Add new...',
            children: null,
            data: {
              id: 0,
              table: table,
              mainfield,
              mainvalue,
            }
          });
          this.loading = false;
          resolve(returntree);
        })
      });
    },
    data_get(table, mainfield, mainvalue, orderby, orderdesc) {
      this.loading = true;
      axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
      const data_get_url = table+'/list?';
      const url = base_url+"/"+data_get_url
              +'orderby='+orderby
              +'&order='+(orderdesc?"DESC":"ASC")
              +'&mainfield='+(mainfield?mainfield:'')
              +'&mainvalue='+(mainvalue?mainvalue:'')
      return new Promise((resolve) => {
        axios.get(
            url,
            {
                headers: {
                    "Accept": "application/json",
                    "Content-type": "application/json",
                }
            }
        )
        .then(resp => {
          resolve(resp.data.result);
        })
      });            
    },
  }
}
</script>
<style>
.maintenance-tree {
  font-size: 16px;
}

.tree-node-inner {
  padding: 4px 0;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
